import React from "react";
import * as CHQ from "chq";

import culturehqbot from "images/badges/culturehqbot.png";
import { t, Trans } from "app/utils";

import LazyEditorOutput from "components/editor/LazyEditorOutput";
import NotificationBody from "./NotificationBody";

const CultureBot = {
  avatar: { thumbUrl: culturehqbot },
  name: t("CultureBot")
};

type AutoRecognizedNotificationProps = {
  notification: CHQ.NotificationAutoRecognized;
};

const AutoRecognizedNotification: React.FC<AutoRecognizedNotificationProps> = ({
  notification
}) => (
  <NotificationBody actor={CultureBot}>
    <Trans>You were recognized by CultureBot: </Trans>
    <LazyEditorOutput output={notification.entity.body} />
  </NotificationBody>
);

export default AutoRecognizedNotification;
